import { defineStore } from "pinia";
import { fetchJobDestinationParams } from "@/api/jobs";
import { useKeyedCache } from "@/composables/keyedCache";
export const useJobDestinationParametersStore = defineStore("jobDestinationParametersStore", () => {
    const { storedItems, getItemById, isLoadingItem } = useKeyedCache((params) => fetchJobDestinationParams({ job_id: params.id }));
    return {
        storedJobDestinationParameters: storedItems,
        getJobDestinationParams: getItemById,
        isLoadingJobDestinationParams: isLoadingItem,
    };
});
